import { useMemo } from 'react';
import useResizeObserver from 'use-resize-observer';

export const useResponsiveCardStyles = () => {
  const { ref, width } = useResizeObserver();

  const responsiveCardStyles = useMemo(() => {
    return {
      gridAutoRows: 'min-content',
      ...((width ?? 0 > 700)
        ? {
            gridTemplateColumns: 'repeat(auto-fill, minmax(19rem, 1fr))',
            '& > *': {
              maxWidth: '25rem',
              justifySelf: 'center',
              width: '100%',
            },
            justifyItems: 'center',
          }
        : {
            gridTemplateColumns: '1fr',
          }),
    };
  }, [width]);

  return useMemo(
    () => ({ containerWidth: width, containerRef: ref, responsiveCardStyles }),
    [width, ref, responsiveCardStyles],
  );
};
